import type React from 'react';

export const onClickHandlerForNonInteractiveElements = (
  onClickHandler: React.MouseEventHandler & React.KeyboardEventHandler,
) => ({
  role: 'button',
  tabIndex: '0',
  onClick: onClickHandler,
  onKeyPress: (event: React.KeyboardEvent) => {
    event.stopPropagation();
    const { keyCode, key } = event;
    if (key === 'Enter') onClickHandler(event);
    else if (keyCode === 13) onClickHandler(event);
  },
});

export default onClickHandlerForNonInteractiveElements;
